import ButtonList from "./ButtonList";
import SearchResultsContainer from "./SearchResultsContainer";
import SideBar from "./SideBar";

function SearchResults() {
    return (
        <div className="flex">
            <div className="left">
                <SideBar />
            </div>
            <div className="right">
                <ButtonList />
                <SearchResultsContainer />
            </div>
        </div>
    )

}

export default SearchResults;